import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import {
  fetchCurrentUser,
  currentUserShowSuccess,
} from '../../ducks/user.duck';

// ================ Action types ================ //

export const SAVE_NOTIFICATION_SETTINGS_REQUEST =
  'app/NotificationsPage/SAVE_NOTIFICATION_SETTINGS_REQUEST';
export const SAVE_NOTIFICATION_SETTINGS_SUCCESS =
  'app/NotificationsPage/SAVE_NOTIFICATION_SETTINGS_SUCCESS';
export const SAVE_NOTIFICATION_SETTINGS_ERROR =
  'app/NotificationsPage/SAVE_NOTIFICATION_SETTINGS_ERROR';

export const SAVE_NOTIFICATION_SETTINGS_CLEAR =
  'app/NotificationsPage/SAVE_NOTIFICATION_SETTINGS_CLEAR';

// ================ Reducer ================ //

const initialState = {
  saveNotificationSettingsError: null,
  saveNotificationSettingsInProgress: false,
  notificationSettingsChanged: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SAVE_NOTIFICATION_SETTINGS_REQUEST:
      return {
        ...state,
        saveNotificationSettingsInProgress: true,
        saveNotificationSettingsError: null,
        notificationSettingsChanged: false,
      };
    case SAVE_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        saveNotificationSettingsInProgress: false,
        notificationSettingsChanged: true,
      };
    case SAVE_NOTIFICATION_SETTINGS_ERROR:
      return {
        ...state,
        saveNotificationSettingsInProgress: false,
        saveNotificationSettingsError: payload,
      };

    case SAVE_NOTIFICATION_SETTINGS_CLEAR:
      return {
        ...state,
        saveNotificationSettingsInProgress: false,
        saveNotificationSettingsError: null,
        notificationSettingsChanged: false,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const saveNotificationSettingsRequest = () => ({
  type: SAVE_NOTIFICATION_SETTINGS_REQUEST,
});
export const saveNotificationSettingsSuccess = () => ({
  type: SAVE_NOTIFICATION_SETTINGS_SUCCESS,
});
export const saveNotificationSettingsError = error => ({
  type: SAVE_NOTIFICATION_SETTINGS_ERROR,
  payload: error,
  error: true,
});

export const saveNotificationSettingsClear = () => ({
  type: SAVE_NOTIFICATION_SETTINGS_CLEAR,
});

// ================ Thunks ================ //

/**
 * Make a notification settings update request to the API and return the current user.
 */
const requestSaveNotificationSettings = params => (dispatch, getState, sdk) => {
  const notificationSettings = params;

  return sdk.currentUser
    .updateProfile(
      { protectedData: { notificationSettings } },
      {
        expand: true,
        include: ['profileImage'],
        'fields.image': ['variants.square-small', 'variants.square-small2x'],
      }
    )
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error(
          'Expected a resource in the sdk.currentUser.updateProfile response'
        );
      }

      const currentUser = entities[0];
      return currentUser;
    })
    .catch(e => {
      dispatch(saveNotificationSettingsError(storableError(e)));
      // pass the same error so that the SAVE_NOTIFICATION_SETTINGS_SUCCESS
      // action will not be fired
      throw e;
    });
};

/**
 * Save notification settings and update the current user.
 */
export const saveNotificationSettings = params => (dispatch, getState, sdk) => {
  dispatch(saveNotificationSettingsRequest());

  const { currentNotificationSettings, ...newSettings } = params;
  console.log('params', params)
  // Check if settings have changed
  const settingsChanged = Object.keys(newSettings).some(
    key => newSettings[key] !== currentNotificationSettings[key]
  );

  if (!settingsChanged) {
    // No changes, just dispatch success
    dispatch(saveNotificationSettingsSuccess());
    return Promise.resolve();
  }

  return (
    dispatch(requestSaveNotificationSettings(newSettings))
      .then(user => {
        dispatch(currentUserShowSuccess(user));
        dispatch(saveNotificationSettingsSuccess());
      })
      // error action dispatched in requestSaveNotificationSettings
      .catch(e => null)
  );
};

export const loadData = (params, search, config) => (
  dispatch,
  getState,
  sdk
) => {
  // Need to get the current user preferences for notifications

  return dispatch(fetchCurrentUser());
};
